import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../Config/BaseUrl";
import { GET_FEECOLLECTION_FAILURE, GET_FEECOLLECTION_REQUEST, GET_FEECOLLECTION_SUCCESS, GET_SPEC_FEECOLLECTION_FAILURE, GET_SPEC_FEECOLLECTION_REQUEST, GET_SPEC_FEECOLLECTION_SUCCESS } from "../../Constants/school_user/FeeDiscount";


const token = localStorage.getItem("token");
const config = {
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  },
};

export const getRegularFeeCollection = (body) => async (dispatch) => {
  try {
    dispatch({ type: GET_FEECOLLECTION_REQUEST });
    const response = await axios.post(
      `${BASE_URL}regular_fee_collection/`,
      body,
      config
    );
    const data = response.data;
    dispatch({ type: GET_FEECOLLECTION_SUCCESS, payload: data });
    return data
  } catch (error) {
    dispatch({ type: GET_FEECOLLECTION_FAILURE, payload: error });
  }
};
export const getSpecialFeeCollection = (body) => async (dispatch) => {
  try {
    dispatch({ type: GET_SPEC_FEECOLLECTION_REQUEST });
    const response = await axios.post(
      `${BASE_URL}regular_special_fee_collection/`,
      body,
      config
    );
    const data = response.data;
    dispatch({ type: GET_SPEC_FEECOLLECTION_SUCCESS, payload: data });
    return data
  } catch (error) {
    dispatch({ type: GET_SPEC_FEECOLLECTION_FAILURE, payload: error });
  }
};
